module.exports = __webpack_public_path__ + "static/media/radio-checked.3d1c8c64.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/radio-checked.svg
// module id = 692
// module chunks = 0